import api from './api'

export const blacklistService = {
  fetchBlacklist(params = {}) {
    const query = new URLSearchParams()
    const { page = 0, size = 10 } = params
    query.append('page', page)
    query.append('size', size)
    return api.get(`/blacklist?${query.toString()}`)
  },

  addToBlacklist(payload) {
    return api.post('/blacklist', payload)
  },

  removeFromBlacklist(payload) {
    return api.post('/blacklist/remove', payload)
  }
}

